module.exports = __webpack_public_path__ + "static/media/reviewdale-text-white.d29bc278.svg";